module.exports = __webpack_public_path__ + "media/images/btn-arrow-8c39159d5fa63417566707d532e6141a.svg";